import {create} from 'zustand';
import IpLocationResponse from "api/model/IpLocationResponse";

export interface LocationStore {
    location?: IpLocationResponse,
    updateLocation: (location: IpLocationResponse) => void,
}

export const useLocationStore = create<LocationStore>((set) => ({
    item: undefined,
    updateLocation: location => set(() => ({location})),
}));
